import React, { useContext } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import ApprovalDetailsPage from './approvals/details/ApprovalDetailsPage';
import ApprovalsPage from './approvals/ApprovalsPage';
import PreferencesPage from './preferences/PreferencesPage';
import FamilyPage from './families/FamilyPage';
import FamiliesPage from './families/FamiliesPage';
import WorkflowDetailsPage from './families/workflows/details/WorkflowDetailsPage';
import ExecutionDetailsPage from './families/executions/ExecutionDetailsPage';
import MobxContext from './mobx/MobxContext';
import CreateExecutionPage from './families/workflows/CreateExecutionPage';
import WorkflowEditPage from './families/workflows/edit/WorkflowEditPage';
import WorkflowCreatePage from './families/workflows/edit/WorkflowCreatePage';
import ExecutionDeploymentActionDetailsPage from './families/executions/ExecutionDeploymentActionDetailsPage';
import ExecutionTestActionDetailsPage from './families/executions/ExecutionTestActionDetailsPage';
import ApiSwaggerDocs from './api/ApiSwaggerDocs';
import AuthenticationService from './auth/AuthenticationService';
import EditFamilySettingsPage from './families/EditFamilySettingsPage';
import CreateFamilyPage from './families/CreateFamilyPage';
import FaroParamSetListPage from './faro/parameters/FaroParamSetListPage';
import FaroParamSetDetailsPage from './faro/parameters/FaroParamSetDetailsPage';
import FaroParamSetEditPage from './faro/parameters/FaroParamSetEditPage';
import FaroParamSetCreatePage from './faro/parameters/FaroParamSetCreatePage';
import FaroDeckDetailsPage from './faro/decks/FaroDeckDetailsPage';
import FaroDeckSearchPage from './faro/decks/FaroDeckSearchPage';
import FaroDeploymentDetailsPage from './faro/deployments/FaroDeploymentDetailsPage';
import FaroDeploymentSearchPage from './faro/deployments/FaroDeploymentSearchPage';
import GroupsPage from './groups/GroupsPage';
import GroupDetailsPage from './groups/GroupDetailsPage';

interface Props {
  authService: AuthenticationService;
}

function AppRoutes(props: Props) {
  const { preferenceStore } = useContext(MobxContext);

  return (
    <Switch>
      <Route path="/families/:familyId/executions/:executionId/deploymentactions/:actionName" component={ExecutionDeploymentActionDetailsPage} />
      <Route path="/families/:familyId/executions/:executionId/testactions/:actionName" component={ExecutionTestActionDetailsPage} />
      <Route path="/families/:familyId/executions/:executionId" component={ExecutionDetailsPage} />
      <Route path="/families/:familyId/workflows/:workflowId/execute" component={CreateExecutionPage} />
      <Route path="/families/:familyId/workflows/:workflowId/edit" component={WorkflowEditPage} />
      <Route path="/families/:familyId/workflows/new" component={WorkflowCreatePage} />
      <Route path="/families/:familyId/workflows/:workflowId" component={WorkflowDetailsPage} />
      <Route path="/families/:familyId/edit" component={EditFamilySettingsPage} />
      <Route path="/families/new" component={CreateFamilyPage} />
      <Route path="/families/:familyId" component={FamilyPage} />
      <Route path="/families" component={FamiliesPage} />
      <Route path="/approvals/:approvalId" component={ApprovalDetailsPage} />
      <Route path="/approvals" component={ApprovalsPage} />
      <Route path="/groups/:groupId" component={GroupDetailsPage} />
      <Route path="/groups" component={GroupsPage} />
      <Route path="/faro/parameters/:accountId/:region/:name/edit" component={FaroParamSetEditPage} />
      <Route path="/faro/parameters/:accountId/:region/:name" component={FaroParamSetDetailsPage} />
      <Route path="/faro/parameters/new" component={FaroParamSetCreatePage} />
      <Route path="/faro/parameters" component={FaroParamSetListPage} />
      <Route path="/faro/decks/:deckName" component={FaroDeckDetailsPage} />
      <Route path="/faro/decks" component={FaroDeckSearchPage} />
      <Route path="/faro/deployments/:accountId/:region/:deploymentName" component={FaroDeploymentDetailsPage} />
      <Route path="/faro/deployments" component={FaroDeploymentSearchPage} />
      <Route path="/preferences" component={PreferencesPage} />
      <Route path="/api-docs" render={() => <ApiSwaggerDocs authService={props.authService} />} />
      <Redirect from="/" to={preferenceStore.recentlyViewedFamilies.length ? `/families/${preferenceStore.recentlyViewedFamilies[0].id}` : '/families'} />
    </Switch>
  );
}

export default AppRoutes;
